import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Brand from "@/components/Brand";
import SiteHead from "@/components/SiteHead";
import api from "@/lib/api";
import { BRAND_NAME } from "@/lib/brand";

export default function BlogTopic() {
  const { cluster } = useParams();
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api.get(`/blog/topics/${cluster}`).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [cluster]);

  const label = (cluster || "").replace(/-/g, " ");
  const title = `${label} guides | ${BRAND_NAME}`;

  return (
    <div className="lp-paper text-stone-900 min-h-screen font-sans antialiased">
      <SiteHead title={title} description={`Mera Startup articles in the ${label} topic cluster.`} path={`/blog/topics/${cluster}`} />
      <header className="sticky top-0 z-50 border-b border-stone-900/10 bg-[#FBF7F0]/85 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/"><Brand variant="light" size="xl" /></Link>
          <Link to="/blog" className="text-sm font-medium text-stone-600">Blog</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12">
        <p className="text-xs font-bold uppercase tracking-wider text-orange-600">Topic cluster</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight capitalize">{label} guides</h1>
        {!items ? (
          <p className="mt-8 text-stone-500">Loading…</p>
        ) : items.length === 0 ? (
          <p className="mt-8 text-stone-500">No articles in this cluster yet. <Link to="/blog" className="underline">Back to blog</Link>.</p>
        ) : (
          <ul className="mt-8 space-y-4">
            {items.map((p) => (
              <li key={p.slug}>
                <Link to={`/blog/${p.slug}`} className="font-semibold text-orange-800 hover:underline">{p.title}</Link>
                {p.excerpt ? <p className="text-sm text-stone-600 mt-1">{p.excerpt}</p> : null}
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
